jQuery(function($){

    // on page load set the media of first item
    $('.drop-down-with-media-on-left.has-media').each(function(index, element) {
        const firstItem = $(element).find('.drop-down .drop-down-item:first-child')
        const mediatype = firstItem.data('mediatype')
        const mediaurl = firstItem.data('mediaurl')

        const mediacontainer = $(element).find('.dropdown-columns .media-container')
        let container = ''
        if(mediatype === 'image') {
            // image
            container = mediacontainer.find('.image-container')
            container.append('<img src="' + mediaurl + '">')
            container.addClass('open')
        } else {
            // video
            container = mediacontainer.find('.video-container')
            container.append('<video autoplay="1" loop="1" muted="1"><source src="' + mediaurl + '"></video>')
            container.addClass('open')
        }

    })

    $('.drop-down-with-media-on-left').on('click', '.title-container', function() {
        if($(this).hasClass('open')) {
            // don't allow closing currently open dropdown so there is always one open
            return
        }
        $(this).parents('.drop-down-with-media-on-left').find('.title-container.open').not(this).removeClass('open')
        $(this).toggleClass('open')

        if(!$(this).parents('.drop-down-with-media-on-left').hasClass('has-media')) {
            // no media, stop here
            return
        }
        
        const parentItem = $(this).parent('.drop-down-item')
        const mediatype = parentItem.data('mediatype')
        const mediaurl = parentItem.data('mediaurl')

        if(mediaurl && $(this).hasClass('open')) {
            // set image/video on left
            const mediacontainer = $(this).parents('.dropdown-columns').find('.media-container')

            let container = ''
            if(mediatype === 'image') {
                // image
                container = mediacontainer.find('.image-container')
                if(container.children().length === 0) {
                    // new element
                    container.append('<img src="' + mediaurl + '">')
                } else {
                    // existing img element
                    if(container.find('img').attr('src') !== mediaurl) {
                        container.find('img').attr('src', mediaurl)
                    }
                }
                mediacontainer.find('.video-container.open').removeClass('open')
                container.addClass('open')
            } else {
                // video
                container = mediacontainer.find('.video-container')
                if(container.children().length === 0) {
                    // new element
                    container.append('<video autoplay="1" loop="1" muted="1"><source src="' + mediaurl + '"></video>')
                } else {
                    // existing video element
                    if(container.find('video source').attr('src') !== mediaurl) {
                        container.find('video source').attr('src', mediaurl)
                        container.find('video')[0].load()
                    }
                }
                mediacontainer.find('.image-container.open').removeClass('open')
                container.addClass('open')
            }
        }
    })
    /* $( window ).on( "resize", function() {
        if ($(window).width() <= 767) {
            $('.drop-down-with-media-on-left.has-media')
          }
    }) */
})